import React from 'react';
import cn from 'classnames';
import Image from '@framework/router/Next/Image';

import introAnimation from './assets/introAnimation.webp';
import paperPlane from './assets/paperPlane.svg';
import FooterPattern from '@framework/ui/Pages/Landing/Sections/FooterPattern';

import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';

import styles from '@/dataroom/ui/components/Landing/VeriSend/Home/home.module.scss';
import baseStyles from '../tenantVeriSend.module.scss';
import commonHomeStyles from '@/dataroom/ui/components/Landing/common/homeSection.module.scss';

const Home = () => (
  <div className={ styles.homeWrp }>
    <div className={ cn(styles.intro) }>
      <div className={ commonHomeStyles.introContainer }>
        <div className={ cn(commonHomeStyles.introContent, styles.introContent) }>
          <h1 className={ cn(commonHomeStyles.introTitle, baseStyles.title, styles.title) }>
            Electronic document delivery made easy
          </h1>
          <div className={ cn(commonHomeStyles.introDescription, baseStyles.description, styles.description) }>
            <p>
              VeriSend is an electronic document delivery and notarization service for capital markets. It’s secure,
              cost effective and backed by fanatical 24x7 support.
            </p>
            <p>VeriSend is free for qualified investors.</p>
          </div>
          <BookDemoButton legacy />
          <GetStartedButton />
        </div>
        <div className={ commonHomeStyles.introAnimation }>
          <div className={ cn(commonHomeStyles.introAnimationContainer, styles.introAnimationContainer) }>
            <div className={ styles.introAnimationShadow } />
            <Image
              src={ introAnimation.src }
              width={ 638 }
              height={ 490 }
              title={ 'Intro' }
              alt={ 'Intro' }
            />
          </div>
        </div>
      </div>
      <div className={ styles.paperPlane }>
        <img src={ paperPlane.src } className={ styles.paperPlane1 } />
        <img src={ paperPlane.src } className={ styles.paperPlane2 } />
        <img src={ paperPlane.src } className={ styles.paperPlane3 } />
      </div>
    </div>
    <FooterPattern />
  </div>
);

export default Home;
